import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/settings/ride_types/'

export default {
  getRideTypes (baseUrl) {
    return axios.get(baseUrl + URL + 'all' ).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  addRideTypeCapacity (baseUrl, data) {
    return axios.get(baseUrl + URL + 'addRideTypeCapacity' + `?rideTypeId=${data.rideTypeId}&maxLuggage=${data.maxLuggage}&numSeats=${data.numSeats}&bodyType=${data.bodyType}` ).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  addRideTypeCapacityRows (baseUrl, data) {
    return axios.post(baseUrl + URL + 'addRideTypeCapacityRows' +  `?rideTypeId=${data.rideTypeId}`, data.rows ).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  deleteRideTypeCapacity (baseUrl, id) {
      return axios.get(baseUrl + URL + 'deleteRideTypeCapacity' + `?id=${id}` ).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
